import moment from 'moment-timezone';
import Formatters, { DEFAULT_TIMEZONE } from '../../shared/utils/Formatters';

export const paymentsSizeText = (upcomingPayments) => {
  return paymentsSize(upcomingPayments) > 1 ? `${paymentsSize(upcomingPayments)} payments ` : 'payment ';
}

export const currencyTotal = upcomingPayments => {
  const totalAmount = total(upcomingPayments);
  return Formatters.currency({ amount: totalAmount });
}

export const daysBeforeDue = upcomingPayments => {
  const today = moment().tz(DEFAULT_TIMEZONE).startOf('day');
  const _dueDate = dueDate(upcomingPayments);
  const inDaysCount = _dueDate.diff(today, 'days');
  const tomorrowMarking = 1;
  const todayMarking = 0;
;

  if (inDaysCount === todayMarking) return 'today, ';
  if (inDaysCount === tomorrowMarking) return 'tomorrow, on ';

  return `in ${inDaysCount} days, on `;
}

export const dueDateHumanized = upcomingPayments => {
  const _dueDate = dueDate(upcomingPayments);
  return Formatters.date(_dueDate);
}

const paymentsSize = upcomingPayments => payments(upcomingPayments).length;

const payments = upcomingPayments => latestRepayments(sortRepaymentsByLatestDue(upcomingPayments));

const total = upcomingPayments => {
  return payments(upcomingPayments).reduce((acc, summary) => acc + summary.payment.total, 0);
}

const sortRepaymentsByLatestDue = (upcomingPayments) => {
  const upcomingPaymentsCopy = upcomingPayments.slice();

  return upcomingPaymentsCopy.sort((summaryA, summaryB) => {
    const summaryADate = moment(summaryA.due_date).tz(DEFAULT_TIMEZONE);
    const summaryBDate = moment(summaryB.due_date).tz(DEFAULT_TIMEZONE);

    return summaryADate - summaryBDate;
  });
}

const latestRepayments = sortedSummaries => {
  const latestRepayment     = sortedSummaries[0];
  const latestRepaymentDate = moment(latestRepayment.due_date).tz(DEFAULT_TIMEZONE);

  return sortedSummaries.filter(summary => {
    const summaryRepaymentDate = moment(summary.due_date).tz(DEFAULT_TIMEZONE);

    return latestRepaymentDate.isSame(summaryRepaymentDate, 'days');
  });
}

const dueDate = upcomingPayments => {
  const dateOfLatestDue = payments(upcomingPayments)[0].due_date;
  return moment(dateOfLatestDue).tz(DEFAULT_TIMEZONE).startOf('day');
}



// WEBPACK FOOTER //
// ./src/features/home/misc/UpcomingPaymentRecapper.js